import { useEffect, useState } from "react";
import cx from "ui/cx";
import Checkbox from "ui/forms/CheckboxOld";
import styles from "./YesNo.module.scss";

export interface YesNoProps extends React.HTMLAttributes<HTMLDivElement> {
  labelA?: string;
  labelB?: string;
  label?: string;
  defaultState?: boolean;
  onUpdate: (state?: boolean) => void;
}

// Presents 2 alternative options with an unset default state, useful in cases where a Checkbox or Toggle don't allow for 3 states.
export default function YesNo({
  onUpdate,
  defaultState,
  label,
  labelA = "Yes",
  labelB = "No",
  className,
  ...props
}: YesNoProps) {
  const [state, setState] = useState<boolean | undefined>(defaultState);
  useEffect(() => {
    onUpdate?.(state);
  }, [state]);

  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {label && <label>{label}</label>}
      <Checkbox
        label={labelA}
        onChange={() => setState((prev) => (prev === true ? undefined : true))}
        checked={state === true}
        data-testid="yes-checkbox"
      />
      <Checkbox
        className={styles.no}
        mark="partialCheck"
        label={labelB}
        onChange={() => setState((prev) => (prev === false ? undefined : false))}
        checked={state === false}
        data-testid="no-checkbox"
      />
    </div>
  );
}
